import { render, staticRenderFns } from "./MasterDataChapterList.vue?vue&type=template&id=422170a3&"
import script from "./MasterDataChapterList.vue?vue&type=script&lang=js&"
export * from "./MasterDataChapterList.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataChapterList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports